import { REASON_FOR_VISIT_ID, REASON_FOR_VISIT_ID_ES } from '@src/components/ReasonForVisit/ReasonForVisit.helpers';
import { DataLayerStepNames } from '@src/constants';
import { DigitalVisitReasonEnum } from '@src/lib/__generated/api';
import { dataLayer } from '@src/services/dataLayer';

interface TrackReasonForVisitParams {
	reasonForVisit: DigitalVisitReasonEnum;
	locale?: string;
	mottoFlow: boolean;
	facilityCode?: string;
	facilityName?: string;
}

export const dataLayerReasonSelected = ({
	reasonForVisit,
	locale,
	mottoFlow,
	facilityCode,
	facilityName,
}: TrackReasonForVisitParams) => {
	const reasonID = locale === 'es-US' ? REASON_FOR_VISIT_ID_ES[reasonForVisit] : REASON_FOR_VISIT_ID[reasonForVisit];

	dataLayer({
		language_preference: locale,
		brand: mottoFlow ? 'mottoaligners' : 'aspendental',
		step_name: DataLayerStepNames.reasonSelect,
		reason_for_visit: reasonForVisit,
		reason_for_visit_id: reasonID,
		...(facilityCode && {
			website_selected_facility_id: facilityCode,
		}),
		...(facilityName && {
			website_selected_facility_name: facilityName,
		}),
	});
};
